import makeUpdateFeatureFile from './makeUpdateFeatureFile.js';

export default function createPubNubMessageHandler(onContextChange, context) {
  const { log } = context;

  const handlers = {
    TaskEnded: makeTaskEndedHandler(),
    AggregateEvent: makeAggregateEventHandler(onContextChange, context),
    ApplicationEvent: makeApplicationEventHandler(onContextChange, context)
  };

  return async message => {
    const handler = handlers[message.type];

    if (!handler) {
      log.error(`No message handler found for message type ${message.type}`);
      return;
    }

    try {
      await handler(message.data);
    } catch (err) {
      log.error(`An error occurred while processing incoming ${message.type}`, message, err);
      // eslint-disable-next-line no-debugger
      debugger;
    }
  };
}

const makeTaskEndedHandler = () => {
  return event => {
    if (typeof window !== 'undefined') {
      return window.dispatchEvent(new CustomEvent('task-ended', { detail: event }));
    }
  };
};

const makeAggregateEventHandler = (onContextChange, context) => {
  const updateFeatureFile = makeUpdateFeatureFile(onContextChange, context);

  return event => {
    if (['FeatureFile'].includes(event.aggregateTypename)) {
      updateFeatureFile(event);
    } else {
      context.db.onDataChange(event);
    }
  };
};

const makeApplicationEventHandler = (onContextChange, context) => {
  return async event => {
    const { type } = event;

    if (type === 'APP_UPGRADED') {
      context.updateAvailable = true;
      onContextChange({ ...context });
    } else if (type === 'ALL_FEATUREFILES_UPDATED') {
      // Trop de fichiers ont changé, on reload
      location.reload();
    } else if (
      type === 'CAN_ACCESS_CHANGED' ||
      type ===
        'UPDATE_AUTHORIZED_DEFINITIONS' /* Legacy : This message type is used by the feature @skyjs/definition-authorized-handler which is deprecate */
    ) {
      context.app.definition = await context.executeApi('/definitions', undefined, 'GET');

      if (event.optimized) {
        context.reset();
      } else {
        // for backwards compatibility
        context.updateApp();
      }

      onContextChange({ ...context });
    }
  };
};
